var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.silo != null)?_c('silo-form',{attrs:{"edit":true,"silo":_vm.silo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }